<h2 mat-dialog-title>Edit {{ this.vendorToEdit?.name ?? "" }}</h2>
<mat-progress-bar
  mode="indeterminate"
  color="accent"
  *ngIf="loading"
></mat-progress-bar>
<mat-dialog-content>
  <form [formGroup]="editVendorForm" class="flex flex-col">
    <mat-form-field class="mb-2">
      <mat-label> Name</mat-label>
      <input
        matInput
        type="text"
        formControlName="name"
        placeholder="Name"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.name.invalid">
        Vendor name is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mb-2">
      <mat-label> Email </mat-label>
      <input
        matInput
        type="text"
        formControlName="email"
        placeholder="Email"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.email.invalid">
        Email is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mb-2">
      <mat-label> First Name </mat-label>
      <input
        matInput
        type="text"
        formControlName="firstName"
        placeholder="First Name"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.firstName.invalid">
        First Name is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mb-2">
      <mat-label> Last Name </mat-label>
      <input
        matInput
        type="text"
        formControlName="lastName"
        placeholder="Last Name"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.lastName.invalid">
        Last Name is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mb-2">
      <mat-label> Phone </mat-label>
      <input
        matInput
        type="text"
        formControlName="phone"
        placeholder="Phone"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.phone.invalid">
        Phone is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mb-2">
      <mat-label> Student Ambassador </mat-label>
      <input
        matInput
        type="text"
        formControlName="studentAmbassador"
        placeholder="Student Ambassador"
        maxlength=""
      />
      <mat-error *ngIf="this.editVendorForm.controls.studentAmbassador.invalid">
        Student Ambassador is required.
      </mat-error>
    </mat-form-field>
    <p>
      <mat-slide-toggle [checked]="this.checked" (click)="checked = !checked">
        {{ this.checked ? "ACTIVE" : "INACTIVE" }}
      </mat-slide-toggle>
    </p>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    (click)="onSubmit()"
    color="accent"
    [disabled]="this.editVendorForm.invalid"
  >
    Submit
  </button>
</mat-dialog-actions>
